import { defaultBscTestnetProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/bsct/default-constants';

export const TRADER_JOE_BSCT_CONTRACT_ADDRESS = '0xf7C6d73336f333b63144644944176072D94128F5';

export const TRADER_JOE_BSCT_PROVIDER_CONFIGURATION = defaultBscTestnetProviderConfiguration;
